<template>
  <ProgressBar
    mode="indeterminate"
    style="height: 6px"
  />
</template>

<script setup lang="ts">
import ProgressBar from 'primevue/progressbar';
</script>